<template>
  <article class="car_info">
      <h2 class="title">排量和年款</h2>
    <ul class="car_brand_detail detail_alone">
      <li v-for="item in models" :key="item.id">
        <a href="javascript:void(0);" class="info" @click.stop="selModel(item)">{{item.name}}</a>
      </li>
    </ul>
  </article>
</template>
<script>
import cache from '../../common/cache'

export default {
  data() {
    return {
      sessionKey: '',
      sessionData: {},
      models: []
    }
  },
  created() {
    let seriesId = this.$route.params.seriesId
    if (seriesId) {
      this.$rest.carInfo.getCarModelList({ mode: 'compatibility' }, `${seriesId}/models`).then((res) => {
        if (res.code === 0) {
          this.models = res.models
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  methods: {
    selModel(v) {
      let from = cache.getSessionData('carModelInfo')
      cache.clearSessionData('carModelInfo')
      this.$router.push({
        path: from,
        query: {
          'car_model_id': v.id,
          'car_model_name': v.name
        }
      })
    }
  }
}

</script>
<style scoped lang="less">
@import "../../stylesheets/modules/car/brand.less";
</style>
